var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('div',{staticClass:"media-preview-item-thumbnail",style:({ width: _vm.size, height: _vm.size })},[(_vm.isImage)?_c('img',{attrs:{"src":_vm.item.url,"alt":_vm.item.alt || _vm.item.name}}):_c('i',{class:_vm.iconClass})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }